<template>
	<el-select remote-show-suffix clearable filterable :style="{ 'width': `${width}` }" :disabled="disabled" :size="size"
		v-model="TypeId" :loading="loading" @focus="SelectFocus" :placeholder="placeholder" @change="TypeChange"
		@clear="TypeClear">
		<el-option v-for="v in TypeList" :key="v[ValueKey]" :label="v[LabelKey]" :value="v[ValueKey]" />
	</el-select>
</template>

<script lang="ts" setup>
import { ref, getCurrentInstance, withDefaults, onMounted, watch } from 'vue';
import translate from '@/api/translate';

interface main {
	id?: string | number,
	size?: string,
	ValueKey?: string,
	LabelKey?: string,
	width?: string | number,
	disabled?: boolean,
	IsAuto?: boolean,
};

const props = withDefaults(defineProps<main>(), {
	id: "",
	size: "default",
	ValueKey: "value",
	LabelKey: "label",
	width: "100%",
	disabled: false,
	IsAuto: false,
});

const { proxy } = getCurrentInstance() as any;
const emits = defineEmits(["update:id", "change", "clear"]);
const TypeId = ref<any>("");
const TypeList = ref<any>([]);
const loading = ref(false);
const placeholder = ref(translate.ShowText('请选择')) // 请选择...

watch(() => props.id, (n: any) => {
	TypeId.value = n;
});

onMounted(() => {
	TypeId.value = props.id;
	if (props.IsAuto) {
		if (proxy.$store.state.IsRefreshInOrderType) {
			GetData();
		} else {
			if (proxy.$store.state.InOrderTypeList.length > 0) {
				TypeList.value = proxy.$store.state.InOrderTypeList;
			} else {
				GetData();
			}
		}
	}
});

const TypeChange = (data: any) => {
	emits("update:id", data);
	emits("change", data);
};
const TypeClear = () => {
	emits("clear");
};
const SelectFocus = () => {
	if (proxy.$store.state.IsRefreshInOrderType) {
		GetData();
	} else {
		if (proxy.$store.state.InOrderTypeList.length > 0) {
			TypeList.value = proxy.$store.state.InOrderTypeList;
		} else {
			GetData();
		}
	}
};
const GetData = () => {
	loading.value = true;
	proxy.$api.tokenRequest({
		url: '/admin/type',
		data: {
			type: 4,
			is_page: 0,
		},
		success: (res: any) => {
			loading.value = false;
			TypeList.value = res.data;
			proxy.$store.commit("GetAllList", {
				type: 21,
				data: res.data,
			});
		},
		fail: () => {
			loading.value = false;
		}
	});
}
</script>

<style></style>